// extracted by mini-css-extract-plugin
module.exports = {"container":"techpackCustomColor_container__29nmA","containerTitle":"techpackCustomColor_containerTitle__3g0N0"};